<ui-section>
    <ui-section-content>
        <div class="grid-container grid-12 pb-4">
            <ui-field class="grid-span-3" [label]="'PAGES.BUSINESS_INDICATORS.INDICATOR_SELECTOR' | translate">
                <ui-select [options]="businessIndicatorsIds()" [required]="true" [(ngModel)]="selectedBusinessIndicatorId">
                    <ng-template let-option="option">{{ (option | businessIndicator)?.name }}</ng-template>
                </ui-select>
            </ui-field>

            <ui-field class="grid-span-2" [label]="'PAGES.BUSINESS_INDICATORS.PERIOD_SELECTOR' | translate">
                <ui-select
                    valueField="periodValue"
                    [options]="periodList()"
                    [sortFn]="sortPeriodDesc"
                    [required]="true"
                    [(ngModel)]="selectedPeriod"
                >
                    <ng-template let-option="option">
                        {{
                            option.periodType === 'YEAR'
                                ? (option.periodValue | translatePeriod)
                                : ('PERIODS.' + option.periodValue | translate)
                        }}
                    </ng-template>
                </ui-select>
            </ui-field>
            <ui-field class="grid-span-2" [label]="'TAILORED_WIDGET.INDICATOR_GAUGE.GAUGE_NAME' | translate">
                <input advizeoInput [required]="true" [(ngModel)]="gaugeName" />
            </ui-field>

            <ui-toggle class="grid-span-2" [label]="'WIDGET.DISPLAY_ESTIMATED' | translate" [(ngModel)]="isEstimated" />
            <ui-toggle
                class="grid-span-2"
                [label]="'TAILORED_WIDGET.INDICATOR_GAUGE.DISPLAY_LEGEND' | translate"
                [(ngModel)]="displayLegend"
            />
        </div>

        <ui-button-toggle
            [options]="[
                { code: 'auto', label: 'TAILORED_WIDGET.INDICATOR_GAUGE.AUTO' | translate },
                { code: 'custom', label: 'TAILORED_WIDGET.INDICATOR_GAUGE.CUSTOM' | translate }
            ]"
            [(ngModel)]="selectedTabId"
        />

        <div class="mt-4">
            @if (selectedTabId() === 'auto') {
                <div class="colors">
                    @for (bandBound of bandBoundaryColors(); track bandBound) {
                        <ui-color-picker [value]="bandBound.color" (valueChange)="colorChange(bandBound.bandBoundaryId, $event)" />
                    }
                </div>
            } @else if (selectedTabId() === 'custom') {
                @let length = customBandBounds().length;

                <div class="flex-row gap-2">
                    <div>
                        @for (bound of customBandBounds(); track $index) {
                            <div class="vertical-center gap-2 pb-2 pl-1">
                                <ui-color-picker [value]="bound.color" (valueChange)="updateColor($index, $event)" />
                                <ui-field class="fit-content">
                                    <input advizeoInput [ngModel]="bound.name" (ngModelChange)="updateName($index, $event)" />
                                </ui-field>

                                <span class="align-right">
                                    {{
                                        ($index !== length - 1
                                            ? 'TAILORED_WIDGET.INDICATOR_GAUGE.FROM'
                                            : 'TAILORED_WIDGET.INDICATOR_GAUGE.MORE_THAN'
                                        ) | translate
                                    }}
                                </span>
                            </div>
                        }
                    </div>
                    <div>
                        @for (bound of customBandBounds(); track $index) {
                            <div class="vertical-center space-between pb-2 gap-2">
                                <ui-field class="fit-content">
                                    <input
                                        advizeoInput
                                        type="number"
                                        [integer]="false"
                                        [allowNegatives]="true"
                                        [ngModel]="bound.minThreshold"
                                        [disabled]="$index > 0"
                                        (ngModelChange)="updateStart($event)"
                                    />
                                </ui-field>
                                @if ($index !== length - 1) {
                                    <span>
                                        {{ 'TAILORED_WIDGET.INDICATOR_GAUGE.TO' | translate }}
                                    </span>
                                    <ui-field class="fit-content">
                                        <input
                                            advizeoInput
                                            type="number"
                                            [integer]="false"
                                            [allowNegatives]="true"
                                            [min]="bound.minThreshold"
                                            [ngModel]="customBandBounds()[$index + 1].minThreshold"
                                            (ngModelChange)="updateThreshold($index + 1, $event)"
                                        />
                                    </ui-field>
                                }
                                <ui-icon-button
                                    iconName="delete"
                                    [advizeoTooltip]="'TAILORED_WIDGET.INDICATOR_GAUGE.DELETE_THRESHOLD' | translate"
                                    [disabled]="$index === 0"
                                    (click)="deleteThreshold($index)"
                                />
                            </div>
                        }
                    </div>
                </div>

                <div class="cursor-hand" role="button" tabindex="0" (click)="addThreshold()" (keydown.enter)="addThreshold()">
                    <ui-icon-button
                        iconName="add"
                        size="small"
                        [advizeoTooltip]="'TAILORED_WIDGET.INDICATOR_GAUGE.ADD_THRESHOLD' | translate"
                    />
                    {{ 'TAILORED_WIDGET.INDICATOR_GAUGE.ADD_THRESHOLD' | translate }}
                </div>
            }
        </div>
    </ui-section-content>
</ui-section>
